module.exports = __webpack_public_path__ + "static/media/rwth.51e46312.webp";